import Text from './text';
export default Text;
